<style lang="sass">
@import ~bi/utilities
@import ~bi/foundation/reset/normalize
@import ~bi/foundation/reset/custom
@import ~bi/foundation/behaviours/behaviours
@import ~bi/brand/variables
+font-face-woff('Brandon', 'assets/fonts/BrandonGrotesque', 'Light', normal, 300)
+font-face-woff('Brandon', 'assets/fonts/BrandonGrotesque', 'Regular', normal, normal)
+font-face-woff('Brandon', 'assets/fonts/BrandonGrotesque', 'Medium', normal, 500)
+font-face-woff('Brandon', 'assets/fonts/BrandonGrotesque', 'Bold', normal, 600)
+font-face-woff('icons', 'assets/icons/icons', 'webfont', normal, normal)
@import ~bi/brand/base/base
@import ~bi/layout/grids/grid
@import assets/sass/m3_variables
@import assets/sass/m3_icons
@import assets/sass/m3_swiper
@import assets/sass/m3
</style>

<template>
    <div
        class="g"
        v-if="$json"
    >
        <Menu :data="$json.menu" :footer="$json.footer" :config="$json.config" v-if="!pageIs('mailing-devis')" />

        <!-- HOME -->
        <template v-if="pageIs('index')" >
            <Hero  />
            <Project contrast="light" />
            <Signaletique :data="$json.si" :link1="$json.config.links.int" :link2="$json.config.links.rooms" contrast="dark" path="signaletique-interieure" />
            <Signaletique :data="$json.se" :link1="$json.config.links.ext" contrast="light" path="signaletique-exterieure" />
            <References contrast="dark" />
            <Icons contrast="light" />
        </template>

        <!-- COVID-19 -->
        <template v-if="pageIs('covid')" >
            <Covid contrast="light" :data="$json.covid.list[0]" />
            <Covid contrast="dark" :data="$json.covid.list[1]" />
            <Covid contrast="light" :data="$json.covid.list[2]" />
            <Covid contrast="dark" :data="$json.covid.list[3]" />
            <Covid contrast="light" :data="$json.covid.list[4]" />
            <!-- <Icons contrast="dark" />
            <References contrast="light"/> -->
        </template>

        <!-- PROJECT -->
        <template v-if="pageIs('project')" >
            <Project contrast="light" />
            <Icons contrast="dark" />
            <References contrast="light"/>
        </template>

        <!-- REFERENCES -->
        <template v-if="pageIs('references')" >
            <ReferencesDetails :data="$json.references.private" contrast="light" :heading="1" />
            <ReferencesDetails :data="$json.references.public" contrast="dark"/>
            <References contrast="light"/>
            <Icons contrast="dark" />
        </template>

        <!-- CONTACT -->
        <template v-if="pageIs('contact')" >
            <ContactForm />
        </template>

        <!-- Devis -->
        <template v-if="pageIs('devis-int')" >
            <DevisForm :data="$json.devis" :config="$json.config" :link1="$json.config.links.rooms" :link2="$json.config.links.ext" />
        </template>
        <template v-if="pageIs('devis-ext')" >
            <DevisForm :data="$json.devis" :config="$json.config" :link1="$json.config.links.int" :link2="$json.config.links.rooms" />
        </template>
        <template v-if="pageIs('devis-rooms')" >
            <DevisForm :data="$json.devis" :config="$json.config" :link1="$json.config.links.int" :link2="$json.config.links.ext" />
        </template>

        <!-- MENTIONS LEGALES -->
        <template v-if="pageIs('legal')" >
            <Legal />
        </template>

        <!-- 404 -->
        <template v-if="pageIs('404')" >
            <NotFound />
        </template>

        <!-- Mailing devis -->
        <template v-if="pageIs('mailing-devis')" >
            <MailingDevis :data="$json.menu" :config="$json.config" />
        </template>

        <Footer />
    </div>
</template>

<script>
import Anchor from './assets/js/Anchor'

import Menu from './components/Menu'
import Hero from './components/Hero'
import Project from './components/Project'
import Signaletique from './components/Signaletique'
import References from './components/References'
import ReferencesDetails from './components/ReferencesDetails'
import Icons from './components/Icons'
import ContactForm from './components/ContactForm'
import DevisForm from './components/DevisForm'
import Legal from './components/Legal'
import NotFound from './components/NotFound'
import Footer from './components/Footer'
import Covid from './components/Covid'
import MailingDevis from './components/MailingDevis'

export default {
    name: 'App',
    mixins: [Anchor],
    components: {
        Menu,
        Hero,
        Project,
        Signaletique,
        References,
        ReferencesDetails,
        Icons,
        ContactForm,
        DevisForm,
        Legal,
        NotFound,
        Footer,
        Covid,
        MailingDevis
    },
    methods: {
        pageIs (page) {
            console.log(this.$landing.project)
            return this.$landing.project === page
        }
    },
    watch: {
        $json (json) {
            this.$nextTick(() => this.goToAnchor())
        }
    }
}
</script>
